import { render } from "./StatsDisplay.vue?vue&type=template&id=9134a82c&scoped=true"
import script from "./StatsDisplay.vue?vue&type=script&lang=js"
export * from "./StatsDisplay.vue?vue&type=script&lang=js"

import "./StatsDisplay.vue?vue&type=style&index=0&id=9134a82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9134a82c"]])

export default __exports__